import { Box, TextField, Divider } from '@mui/material';
import { MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import React, { useEffect, useState } from 'react';
import useVendorBooth from 'src/hooks/useVendorBooth';
import CategoryMultiSelect from '../controls/CategoryMultiSelect';
import MediaUpload from 'src/components/MediaUpload';
import TextLabel from '../TextLabel';
// import Joyride from 'react-joyride';

function isValidUrl(url) {
  if (!url || url === '') return true;

  try {
    new URL(url);
    return true;
  } catch (_) {
    return (url.startsWith('www.') && url.endsWith('.com')) || url.startsWith('/media');
  }
}
const VendorBoothSettings = () => {
  const { vendorBooth, updateProperty } = useVendorBooth();

  const [boothName, setBoothName] = useState<string>('');
  const [boothType, setBoothType] = useState<string>('');
  const [boothShortdescription, setBoothShortdescription] = useState<string>('');
  const [topShowDealsUrl, setTopShowDealsUrl] = useState<string>('');
  const [websiteUrl, setWebsiteUrl] = useState<string>('');
  const [videoUrl, setVideoUrl] = useState<string>('');
  const [catalogUrl, setCatalogUrl] = useState<string>('');

  useEffect(() => {
    //Load booth properties
    if (vendorBooth && vendorBooth.boothProperties && vendorBooth.boothProperties.length > 0) {

      //Booth type is converted to string array and passed to the category multi select
      setBoothType(vendorBooth.boothProperties.find((x) => x.alias === 'boothType')?.value?.toString() ?? '');

      setBoothShortdescription(vendorBooth.boothProperties.find((x) => x.alias === 'boothShortDescription')?.value?.toString() ?? '');
      setTopShowDealsUrl(vendorBooth.boothProperties.find((x) => x.alias === 'topShowDealsUrl')?.value?.toString() ?? '');
      setWebsiteUrl(vendorBooth.boothProperties.find((x) => x.alias === 'websiteUrl')?.value?.toString() ?? '');
      setVideoUrl(vendorBooth.boothProperties.find((x) => x.alias === 'mainBoothVideoUrl')?.value?.toString() ?? '');
      setCatalogUrl(vendorBooth.boothProperties.find((x) => x.alias === 'catalogUrl')?.value?.toString() ?? '');
      setBoothName(vendorBooth.boothProperties.find((x) => x.alias === 'boothName')?.value?.toString() ?? '');
    }
  }, [vendorBooth, vendorBooth.boothProperties]);

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    e.preventDefault();
    updateProperty(e.target.id, e.target.value);
  };

  const categoryChange = (event: MultiSelectChangeEvent) => {
    let selectedCategories = event.value as string[];

    //Convert the array to a comma separated string
    setBoothType(selectedCategories.join(','));
    updateProperty('boothType', selectedCategories.join(','));
  };

  const Required = ({ value, ...restProps }) => {
    //value can be a string or an array. if any element in the array is true then return null

    if (Array.isArray(value)) {
      for (let i = 0; i < value.length; i++) {
        if (value[i] !== '') return null;
      }
    } else if (value) return null;

    return (
      <span {...restProps} style={{ color: 'red' }}>
        * Required
      </span>
    );
  };

  const boothImageUdi = vendorBooth?.boothProperties?.find((x) => x.alias === 'mainBoothImage')?.value?.toString() ?? '';
  const logoUdi = vendorBooth?.boothProperties?.find((x) => x.alias === 'boothLogo')?.value?.toString() ?? '';

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontStyle: 'italic', fontSize: 13 }}>* Please fill in all fields marked required or the booth will not be active</span>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontStyle: 'italic', fontSize: 13 }}>* Fields will auto-save as you go</span>
        </Box>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontStyle: 'italic', fontSize: 13 }}>* Changes may take a few minutes to show up on the booth website</span>
        </Box>
        <Box sx={{ mb: 3, display: 'flex', flexDirection: 'column' }}>
          <TextLabel>
            Booth Name <span style={{ fontStyle: 'italic', fontFamily: 'sans-serif', fontSize: 8 }}>- Please avoid periods and special characters</span>
            <Required value={boothName} />
          </TextLabel>
          <TextField id="boothName" variant="outlined" sx={{ minWidth: 300 }} value={boothName} onChange={(e) => setBoothName(e.target.value)} onBlur={handleOnBlur} />
        </Box>
        <Box sx={{ mb: 3 }}>
          <CategoryMultiSelect style={{ width: '100%' }} onChange={categoryChange} initialValue={boothType.split(',')} />
        </Box>
        <Box sx={{ mb: 3 }}>
          <TextLabel style={{ float: 'left' }}>
            Company Description <Required value={boothShortdescription} />
          </TextLabel>
          <TextField
            id="boothShortDescription"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            value={boothShortdescription}
            onChange={(e) => setBoothShortdescription(e.target.value)}
            onBlur={handleOnBlur}
          />
        </Box>
      </Box>

      <Box className="field-group field-group__booth-media">
        <h3>Links</h3>

        <Box sx={{ mb: 4, mt: 1 }}>
          <TextLabel>Website Url</TextLabel>
          <TextField
            error={!isValidUrl(websiteUrl)}
            helperText={!isValidUrl(websiteUrl) ? 'must be a valid url' : ''}
            id="websiteUrl"
            variant="outlined"
            fullWidth
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            onBlur={handleOnBlur}
          />
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ pb: 4 }}>
          <Box sx={{ mb: 4 }}>
            <TextLabel>Catalog Url</TextLabel>
            <TextField
              error={!isValidUrl(catalogUrl)}
              helperText={!isValidUrl(catalogUrl) ? 'must be a valid url' : ''}
              id="catalogUrl"
              variant="outlined"
              fullWidth
              value={catalogUrl}
              onChange={(e) => setCatalogUrl(e.target.value)}
              onBlur={handleOnBlur}
            />

            <div style={{ padding: '10px 0 5px 0' }}>
              <b>OR</b>
            </div>

            {/* Media/Image input *name* must match the booth property alias */}
            <MediaUpload title="Upload Media" id="catalogMedia" hints={['Must be less than 200MB']} />
          </Box>

          <Divider sx={{ mt: 4, mb: 4 }} />

          <Box>
            <TextLabel>Show Spotlight Url</TextLabel>
            <TextField
              error={!isValidUrl(topShowDealsUrl)}
              helperText={!isValidUrl(topShowDealsUrl) ? 'must be a valid url' : ''}
              id="topShowDealsUrl"
              variant="outlined"
              fullWidth
              value={topShowDealsUrl}
              onChange={(e) => setTopShowDealsUrl(e.target.value)}
              onBlur={handleOnBlur}
            />
            <div style={{ padding: '10px 0 5px 0' }}>
              <b>OR</b>
            </div>
            <MediaUpload title="Upload Spotlight Ad" id="topShowDealsMedia" hints={['Must be less than 200MB']} />
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box>
            <TextLabel>
              Main Video Url <Required value={[videoUrl, boothImageUdi]} />
            </TextLabel>
            <TextField
              style={{ backgroundColor: 'white' }}
              error={!isValidUrl(videoUrl)}
              helperText={!isValidUrl(videoUrl) ? 'must be a valid url' : ''}
              id="mainBoothVideoUrl"
              variant="outlined"
              fullWidth
              value={videoUrl}
              onChange={(e) => setVideoUrl(e.target.value)}
              onBlur={handleOnBlur}
            />

            <div style={{ padding: '10px 0 5px 0' }}>
              <b>OR</b>
            </div>

            <MediaUpload
              title="Upload Main Booth Image"
              showRequiredText={!boothImageUdi && !videoUrl}
              id="mainBoothImage"
              hints={['Image must be exactly 450x380 pixels', 'Must be less than 3MB in size']}
            />
          </Box>

          <Divider sx={{ my: 4 }} />

          <Box sx={{ mb: 4 }}>
            <MediaUpload title="Upload Logo" showRequiredText={logoUdi === ''} id="boothLogo" hints={['Must be less than 3MB in size']} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default VendorBoothSettings;
